module.exports = __webpack_public_path__ + "img/71ecd17.webp";